import React, { useContext, useState } from "react";
import { postData } from "src/actions/postData";
import { notify } from "src/services/Notification/Notification";
import userContext from "src/context/userContext";
import { useLocation } from "react-router-dom";

/**
  کامپوننت پرسشنامه بدون هیچ وابستگی خارجی.
  آن را در یک فایل مثل QuestionnaireForm.jsx قرار بده و در پروژه‌ات import کن.
*/

export default function Questionnaire() {
    const [form, setForm] = useState({ jobTitle: "" });
    const [submitted, setSubmitted] = useState(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");
    const token = params.get("t");
    const { user } = useContext(userContext);
    

    const questions = [
        {
            section: "شناخت شغل و وظایف",
            items: [
                "مهم‌ترین وظایف و مسئولیت‌های این سمت چیست؟",
                "چه فعالیت‌هایی بیشترین زمان و انرژی را در این شغل به خود اختصاص می‌دهد؟",
                "چه تفاوتی میان وظایف رسمی و وظایف عملی روزانه این سمت وجود دارد؟",
                "کدام واحدها یا حوزه های دیگر در ارتباط با این شغل می باشند؟ نوع ارتباط را مشخص نمایید.",
            ],
        },
        {
            section: "شرایط احراز و الزامات",
            items: [
                "چه شرایط تحصیلی، تجربی یا مهارتی برای احراز این سمت ضروری است؟",
                "کدام ویژگی‌های فردی یا رفتاری باعث موفقیت بیشتر در این شغل می‌شود؟",
                "چه تجربه‌های کاری پیشین بیشترین آمادگی را برای این سمت ایجاد می‌کنند؟",
            ],
        },
        {
            section: "شایستگی‌های عمومی",
            items: [
                "کدام شایستگی‌های رفتاری و عمومی برای این سمت حیاتی هستند؟",
                "تجربه شما نشان داده کدام شایستگی عمومی بیشترین تأثیر را بر عملکرد دارد؟",
                "در تعامل با سایر واحدها، چه مهارت‌های ارتباطی بیشترین اهمیت را دارند؟",
            ],
        },
        {
            section: "شایستگی‌های اختصاصی",
            items: [
                "چه دانش‌ها یا مهارت‌های تخصصی برای این شغل ضروری است؟",
                "در شرایط بحرانی یا پیچیده، کدام شایستگی اختصاصی بیشترین نقش را ایفا می‌کند؟",
                "چه فناوری‌ها یا ابزارهای تخصصی باید فرد در این سمت به آن‌ها مسلط باشد؟",
            ],
        },
        {
            section: "چالش‌ها و فرصت‌ها",
            items: [
                "مهم‌ترین چالش‌های این سمت چیست و چگونه باید با آن‌ها مواجه شد؟",
                "چه فرصت‌هایی برای توسعه شایستگی‌ها در این شغل وجود دارد؟",
                "چه عواملی بیشترین فشار یا استرس را در این سمت ایجاد می‌کنند؟",
            ],
        },
        {
            section: "آینده‌نگری و تحول",
            items: [
                "با توجه به تغییرات فناوری و نیازهای جدید سازمان، چه شایستگی‌های تازه‌ای باید به این سمت اضافه شود؟",
                "چه تغییراتی در شرایط احراز یا الزامات این شغل در آینده پیش‌بینی می‌کنید؟",
                "این سمت در آینده چه نقشی در تحول سازمان ایفا خواهد کرد؟",
            ],
        },
        {
            section: "جمع‌بندی و توصیه‌ها",
            items: [
                "اگر بخواهید سه شایستگی کلیدی را برای این شغل نام ببرید، کدام‌ها خواهند بود؟",
                "چه توصیه‌ای برای طراحی مدل شایستگی اختصاصی این سمت دارید؟",
                "چه شاخص هایی برای ارزیابی عملکرد در این شغل پیشنهاد می کنید؟",
            ],
        },
    ];

    const handleChange = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSubmitted(true);

        await postData("/questionnaires", {
            jobId: parseInt(jobId),
            userId: parseInt(user.id),
            data: form
        }, () => {
            // این اکشن بعد از موفقیت اجرا می‌شود
            console.log("Questionnaire saved successfully");
            notify("پرسشنامه با موفقیت ثبت شد.");
        });
        window.open(`${process.env.REACT_APP_DATA_ENTRY_URL}?t=${token}&id=${jobId}&step=start`)
    };

    const resetForm = () => {
        setForm({ jobTitle: form.jobTitle || "" }); // اگر می‌خواهی عنوان هم پاک شود، از setForm({ jobTitle: "" })
        setSubmitted(false);
    };

    const downloadJSON = () => {
        const dataStr = JSON.stringify(form, null, 2);
        const blob = new Blob([dataStr], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = (form.jobTitle || "questionnaire") + ".json";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    };

    const styles = {
        container: { maxWidth: 900, margin: "24px auto", padding: 16 },
        card: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 16, marginBottom: 16 },
        header: { marginBottom: 12 },
        label: { display: "block", marginBottom: 6, fontWeight: 600 },
        input: { width: "100%", padding: 10, borderRadius: 8, border: "1px solid #cbd5e1", boxSizing: "border-box" },
        textarea: { width: "100%", padding: 10, borderRadius: 8, border: "1px solid #cbd5e1", minHeight: 120, boxSizing: "border-box" },
        btn: { padding: "10px 16px", borderRadius: 10, border: "none", cursor: "pointer" },
        primary: { background: "#0369a1", color: "white" },
        secondary: { background: "#e2e8f0", color: "#0f172a", marginLeft: 8 },
        preview: { whiteSpace: "pre-wrap", background: "#f8fafc", padding: 12, borderRadius: 8, border: "1px solid #e6eef6" },
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* متن مقدماتی و راهنمای پاسخ‌گویی */}
                <div style={styles.header}>
                    <h1 style={{ margin: 0 }}>پرسشنامه طراحی مدل شایستگی</h1>
                    <p style={{ marginTop: 8, color: "#374151", lineHeight: 1.8 }}>
                        مدیران و خبرگان محترم
                        <br />
                        با سلام و احترام؛
                        <br />
                        در راستای اجرای طرح «طراحی مدل شایستگی اختصاصی برای ۲۰ سمت کلیدی شعب و مراکز درمانی سازمان تأمین اجتماعی»، پرسشنامه‌ای نیمه‌ساختار‌یافته و باز تهیه گردیده است. هدف از این پرسشنامه، شناسایی شایستگی‌های عمومی و اختصاصی مشاغل، تحلیل وظایف و الزامات عملکردی، و بهره‌گیری از تجربه‌های ارزشمند جنابعالی در ارتقاء کیفیت منابع انسانی سازمان می‌باشد.
                        <br />
                        <br />
                        <strong>راهنمای پاسخ‌گویی</strong>
                        <br />
                        ۱. پاسخ‌ها را بر پایه تجربه‌های واقعی، مشاهدات عملی و دانش تخصصی خود ارائه فرمایید.
                        <br />
                        ۲. در هر سؤال، در صورت امکان بین شایستگی‌های عمومی (رفتاری) و اختصاصی (تخصصی) تفکیک قائل شوید.
                        <br />
                        ۳. برای هر شایستگی، سطح مهارت مورد انتظار (پایه، متوسط، پیشرفته، خبره) را مشخص کنید.
                        <br />
                        ۴. مثال‌ها و نمونه‌های عملی از موفقیت‌ها یا چالش‌های مرتبط با هر سمت را بیان نمایید.
                        <br />
                        ۵. به تغییرات آینده در فناوری، قوانین یا نیازهای سازمان اشاره کنید و شایستگی‌های جدید مورد نیاز را توضیح دهید.
                        <br />
                        ۶. در پایان هر بخش، جمع‌بندی کوتاهی از شایستگی‌های کلیدی مورد نظر ارائه دهید.
                        <br />
                        ۷. تمامی اطلاعات ارائه‌شده صرفاً برای اهداف پژوهشی و طراحی مدل شایستگی استفاده خواهد شد و محرمانگی آن تضمین می‌گردد.
                        <br />
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* <div style={{ marginBottom: 12 }}>
            <label style={styles.label}>سمت شغلی</label>
            <input
              type="text"
              style={styles.input}
              value={form.jobTitle || ""}
              onChange={(e) => handleChange("jobTitle", e.target.value)}
              placeholder="مثال: مدیر شعبه"
            />
          </div> */}

                    {questions.map((q, i) => (
                        <section key={i} style={{ marginBottom: 14 }}>
                            <div style={{ marginBottom: 8 }}>
                                <h2 style={{ margin: 0, fontSize: 18 }}>{q.section}</h2>
                            </div>

                            {q.items.map((item, idx) => {
                                // کلید یکتا برای هر فیلد
                                const key = `q_${i}_item_${idx}`;
                                return (
                                    <div key={key} style={{ marginBottom: 10 }}>
                                        <label style={styles.label}>{item}</label>
                                        <textarea
                                            style={styles.textarea}
                                            value={form[key] || ""}
                                            onChange={(e) => handleChange(key, e.target.value)}
                                            placeholder="پاسخ خود را اینجا بنویسید..."
                                        />
                                    </div>
                                );
                            })}
                        </section>
                    ))}

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                        <button
                            type="button"
                            style={{ ...styles.btn, ...styles.secondary }}
                            onClick={resetForm}
                        >
                            پاک‌سازی پاسخ‌ها
                        </button>
                        <button type="submit" style={{ ...styles.btn, ...styles.primary }}>
                            ارسال پرسشنامه
                        </button>
                    </div>
                </form>

                {/* {submitted && (
                    <div style={{ marginTop: 16 }}>
                        <h3 style={{ marginBottom: 8 }}>پاسخ‌ها ثبت شد</h3>
                        <div style={styles.preview}>{JSON.stringify(form, null, 2)}</div>
                        <div style={{ marginTop: 8, textAlign: "right" }}>
                            <button style={{ ...styles.btn, ...styles.primary }} onClick={downloadJSON}>
                                دانلود JSON
                            </button>
                        </div>
                    </div>
                )} */}
            </div>


        </div>
    );
}
